import ImageInput from "./ImageInput";

// One field control by type (Bootstrap)
export default function PreviewField({
  field,
  value,
  setValue,
  error,
  uploadImage,
}) {
  const f = field;
  const invalid = !!error;
  const ctlCls = "form-control" + (invalid ? " is-invalid" : "");
  const selCls = "form-select" + (invalid ? " is-invalid" : "");

  let control = null;
  if (["text", "email", "phone", "number"].includes(f.type)) {
    const t =
      f.type === "number"
        ? "number"
        : f.type === "email"
          ? "email"
          : f.type === "phone"
            ? "tel"
            : "text";
    control = (
      <input
        type={t}
        className={ctlCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  } else if (f.type === "textarea") {
    control = (
      <textarea
        rows={3}
        className={ctlCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  } else if (f.type === "select") {
    control = (
      <select
        className={selCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      >
        <option value="">Select…</option>
        {(f.options || []).map((o) => (
          <option key={o}>{o}</option>
        ))}
      </select>
    );
  } else if (f.type === "boolean") {
    control = (
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`b-${f.key}`}
          checked={!!value}
          onChange={(e) => setValue(e.target.checked)}
        />
        <label className="form-check-label" htmlFor={`b-${f.key}`}>
          Yes
        </label>
      </div>
    );
  } else if (f.type === "date") {
    control = (
      <input
        type="date"
        className={ctlCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  } else if (f.type === "time") {
    control = (
      <input
        type="time"
        className={ctlCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  } else if (f.type === "datetime") {
    control = (
      <input
        type="datetime-local"
        className={ctlCls}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  } else if (f.type === "image" || f.type === "image_multi") {
    control = (
      <ImageInput
        field={f}
        value={value}
        setValue={setValue}
        uploadImage={uploadImage}
        invalid={invalid}
      />
    );
  }

  return (
    <div className="mb-3">
      <label className="form-label fw-medium">
        {f.label}
        {f.required && <span className="text-danger ms-1">*</span>}
      </label>
      {control}
      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
}
